
import { Vue } from "vue-class-component";
import { imgsList } from "../../assets/homeData";
export default class CoreFunc extends Vue {
  coreData = imgsList;
}
